import { ShopItemType } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { ArrowsShop } from 'src/components/svg/Arrows';
import coin from 'src/assets/images/shop/shopCoin.webp';
import { FC } from 'react';

interface FreespinsPurchaseBlockProps {
  item?: ShopItemType;
  className?: string;
  customCoinsKey?: string;
}

export const FreespinsPurchaseBlock: FC<FreespinsPurchaseBlockProps> = ({
  item,
  customCoinsKey = 'shop.foxCoins'
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center pt-[13px] pb-10">
      <p className="text-sp_title text-3xl font-bold pb-2.5 text-center">{t('shop.bonusSpins')}</p>
      <div className="flex flex-row justify-between w-full px-5 gap-2.5">
        <div className="flex flex-col items-center">
          <p className="text-base text-sp_text font-bold first-letter:uppercase text-center">
            {t(customCoinsKey)}
          </p>
          <div className="flex flex-row items-center gap-[5px]">
            <img src={coin} alt="coin" className="w-6" />
            <p className="text-xl text-sp_text font-bold">{item?.costPoints}</p>
          </div>
        </div>
        <ArrowsShop />
        <div className="flex flex-col items-center">
          <p className="text-base text-sp_text font-bold text-center">{t('freeSpins.freeSpins')}</p>
          <p className="bg-sp_freespins_number_bg text-xl font-bold text-center rounded-[20px] min-w-[66px] py-[5px] text-sp_freespins_number ">
            {item?.freeSpins?.number}
          </p>
        </div>
      </div>
    </div>
  );
};
